import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RegionComponent } from './region.component';

const SECURITY_ROUTES: Routes = [
  { path: 'security/region', component: RegionComponent }
];

@NgModule({
  imports: [RouterModule.forChild(SECURITY_ROUTES)],
  exports: [RouterModule]
})
export class RegionRoutingModule { }
